import { useState, useEffect, useRef } from 'react';
import '../styles/FiltrosBusqueda.css';

const FILTROS_VACIOS = {
  busqueda: '',
  categoria: '',
  categoriasMatch: [],
  precioMin: '',
  precioMax: '',
};

export default function FiltrosBusqueda({ onFiltrar, categoriaExterna }) {
  const [filtros, setFiltros] = useState(FILTROS_VACIOS);
  const [categorias, setCategorias] = useState([]);
  const prevCatExterna = useRef(undefined);

  useEffect(() => {
    fetch('/api/categorias')
      .then(res => res.json())
      .then(data => setCategorias(Array.isArray(data) ? data : []))
      .catch(() => setCategorias([]));
  }, []);

  // Sync when a category card is clicked externally
  useEffect(() => {
    if (categoriaExterna === undefined) return;
    if (categoriaExterna === prevCatExterna.current) return;
    prevCatExterna.current = categoriaExterna;
    const nombre = categoriaExterna || '';
    if (!nombre) {
      const nuevos = { ...FILTROS_VACIOS };
      setFiltros(nuevos);
      onFiltrar(nuevos);
      return;
    }
    const cat = categorias.find(c => c.nombre === nombre);
    const hijos = cat ? categorias.filter(c => c.parent_id === cat._id).map(c => c.nombre) : [];
    const nuevos = { ...filtros, categoria: nombre, categoriasMatch: [nombre, ...hijos] };
    setFiltros(nuevos);
    onFiltrar(nuevos);
  }, [categoriaExterna]);

  const handleChange = (campo, valor) => {
    const nuevos = { ...filtros, [campo]: valor };
    setFiltros(nuevos);
    onFiltrar(nuevos);
  };

  const handleCategoriaChange = (nombreSeleccionado) => {
    if (!nombreSeleccionado) {
      const nuevos = { ...filtros, categoria: '', categoriasMatch: [] };
      setFiltros(nuevos);
      onFiltrar(nuevos);
      return;
    }
    // Find the selected category by name, then collect subcategory names
    const cat = categorias.find(c => c.nombre === nombreSeleccionado);
    const hijos = cat
      ? categorias.filter(c => c.parent_id === cat._id).map(c => c.nombre)
      : [];
    const match = [nombreSeleccionado, ...hijos];
    const nuevos = { ...filtros, categoria: nombreSeleccionado, categoriasMatch: match };
    setFiltros(nuevos);
    onFiltrar(nuevos);
  };

  const limpiar = () => {
    setFiltros(FILTROS_VACIOS);
    onFiltrar(FILTROS_VACIOS);
  };

  const hayFiltrosActivos =
    filtros.busqueda || filtros.categoria || filtros.precioMin || filtros.precioMax;

  const padres = categorias
    .filter(c => !c.parent_id)
    .sort((a, b) => a.nombre.localeCompare(b.nombre));

  const hijosde = (parentId) =>
    categorias
      .filter(c => c.parent_id === parentId)
      .sort((a, b) => a.nombre.localeCompare(b.nombre));

  return (
    <div className="filtros-contenedor">
      {/* Búsqueda por nombre */}
      <div className="filtro-grupo filtro-busqueda">
        <span className="filtro-icono">🔍</span>
        <input
          type="text"
          className="filtro-input"
          placeholder="Buscar producto..."
          value={filtros.busqueda}
          onChange={e => handleChange('busqueda', e.target.value)}
        />
      </div>

      {/* Categoría */}
      <div className="filtro-grupo">
        <select
          className="filtro-select"
          value={filtros.categoria}
          onChange={e => handleCategoriaChange(e.target.value)}
        >
          <option value="">Todas las categorías</option>
          {padres.map(padre => {
            const subs = hijosde(padre._id);
            if (subs.length === 0) {
              return (
                <option key={padre._id} value={padre.nombre}>
                  {padre.nombre}
                </option>
              );
            }
            return (
              <optgroup key={padre._id} label={padre.nombre}>
                <option value={padre.nombre}>{padre.nombre} (todas)</option>
                {subs.map(sub => (
                  <option key={sub._id} value={sub.nombre}>
                    ↳ {sub.nombre}
                  </option>
                ))}
              </optgroup>
            );
          })}
        </select>
      </div>

      {/* Rango de precio */}
      <div className="filtro-grupo filtro-precio">
        <span className="filtro-label">$</span>
        <input
          type="number"
          className="filtro-input filtro-precio-input"
          placeholder="Mín"
          min="0"
          value={filtros.precioMin}
          onChange={e => handleChange('precioMin', e.target.value)}
        />
        <span className="filtro-separador">—</span>
        <input
          type="number"
          className="filtro-input filtro-precio-input"
          placeholder="Máx"
          min="0"
          value={filtros.precioMax}
          onChange={e => handleChange('precioMax', e.target.value)}
        />
      </div>

      {/* Limpiar */}
      {hayFiltrosActivos && (
        <button className="filtro-btn-limpiar" onClick={limpiar} title="Limpiar filtros">
          ✕ Limpiar
        </button>
      )}
    </div>
  );
}
